export interface FetchedPage<T> {
  content: T[];
  totalPages: number;
}

/**
 * Récupère toutes les pages d'un endpoint paginé. Utile quand la liste reçue sert d'état complet
 * côté front : une page manquante y est indistinguable d'une suppression côté serveur.
 */
export const fetchAllPages = async <T>(
  fetchPage: (page: number) => Promise<FetchedPage<T>>,
): Promise<T[]> => {
  const firstPage = await fetchPage(0);

  if (firstPage.totalPages <= 1) {
    return firstPage.content;
  }

  const nextPages = await Promise.all(
    Array.from({ length: firstPage.totalPages - 1 }, (_, index) => fetchPage(index + 1)),
  );

  return [firstPage, ...nextPages].flatMap((page) => page.content);
};
